enum TitleType {
    EVENT_SHARK_PHASE = "event_shark",
    CREW_PHASE = "hunters"
}

export default TitleType